<template>
  <div>
    <v-select
      label="label"
      :filterable="false"
      :options="options"
      v-model="selectEntity"
      @input="onChangeValue"
      @search="onSearch"
      @search:focus="onFocus"
      @search:blur="onBlur"
      :disabled="disabled"
      ref="select"
    >
      <template slot="no-options">Pesquise pelo nome do país</template>
    </v-select>

    <input
      v-if="name"
      type="hidden"
      :name="name"
      :value="selectEntity !== null ? selectEntity.value : ''"
      class="form-control"
    />
    <input
      v-if="name"
      type="hidden"
      :name="name + '-label'"
      :value="selectEntity !== null ? (selectEntity.label ? selectEntity.label.trim() : '') : ''"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: false,
    },
    value: {
      required: false,
      default: null,
    },
    disabled: {
      required: false,
      default: false,
    },
    isMercosul: {
      required: false,
      default: false
    }
  },
  data: () => ({
    selectEntity: null,
    options: [],
    searchTimeoutId: null,
    scrollableEl: null,
  }),
  watch: {
    value: function (val) {
      if (val && val.value !== null) {
        if (!val.label || !val.uf) {
          this.loadMunicipioData(val.value);
        } else {
          this.selectEntity = val;
        }
      }
    },
    scrollableEl: function(newVal, oldVal) {
      oldVal && oldVal.removeAttribute("style");
    }
  },
  methods: {
    onSearch(search, loading) {
      if (search.length < 3) {
        return;
      }

      clearTimeout(this.searchTimeoutId);
      loading(true);

      this.searchTimeoutId = setTimeout(() => {

        const formData = new FormData();
        formData.set("term", search);

        const url = '/util/get-pais-mercosul-autocomplete'

        window.api
          .fetch(url, {
            method: 'POST',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            const items = [];
            Array.isArray(response) &&
              response.forEach((item) => {
                items.push({
                  label: item.value,
                  value: item.id,
                  // uf: item.uf,
                });
              });

            this.options = items;

            this.onFocus();

            loading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }, 2000);
    },
    onChangeValue() {
      if (!this.selectEntity) {
        this.selectEntity = {
          label: null,
          value: null,
          uf: null
        }
      }
      this.$emit("input", this.selectEntity);
    },
    onFocus() {
      setTimeout(() => {
        this.scrollableEl = window.getScrollParent(this.$refs["select"].$el.parentElement);

        if (this.scrollableEl.scrollHeight > this.scrollableEl.clientHeight) {
          this.scrollableEl.style.height = this.scrollableEl.scrollHeight + 20 + "px";
        }
      }, 100);
    },
    onBlur() {
      if (this.scrollableEl) {
        this.scrollableEl.removeAttribute("style");
      }
    },
    loadMunicipioData(codMunicipio) {
      // const formData = new FormData();
      // formData.set("cod-municipio", codMunicipio);

      // window.api
      //   .fetch("/public/get-municipio-dados", {
      //     method: 'POST',
      //     data: formData,
      //     headers: { "Content-Type": "multipart/form-data" },
      //   })
      //   .then((response) => {
      //     this.selectEntity = {
      //       // label: response.descricao,      //FIX to nacionalidade
      //       value: value,
      //       uf: response.uf
      //     };

      //     this.onChangeValue();
      //   });
    }
  },
  mounted() {
    if (this.value && this.value.value !== null) {
      this.selectEntity = this.value;
    }
  },
};
</script>
<style lang="scss" scoped>
.options {
  display: none;
}

/deep/ {
  ul {
    li,
    li:hover {
      display: list-item;
      width: auto;
      border: none;
      border-radius: 0;
      padding: 5px 10px;
      box-shadow: none;
    }

    li:hover {
      background-color: #6f7efb;
    }
  }

  button {
    background: transparent !important;
    border: none !important;

    &:active {
      background: transparent !important;
      border: none !important;
    }
  }

  input {
    text-transform: unset;
  }

  .vs--searchable .vs__dropdown-toggle {
    background: #fff;
  }
}
</style>
